const baseUrl =  process.env.REACT_APP_ENV == "development" ? 
`${process.env.REACT_APP_API_DEV_BASE_URL}/api/v1/` : `${process.env.REACT_APP_API_PROD_BASE_URL}/api/v1/`

// console.log("REACT_APP_ENV" ,process.env.REACT_APP_ENV)
// console.log("baseUrl" ,baseUrl)
//LOGIN
export const POST_LOGIN = `${baseUrl}auth/login`;

// Profile
export const VIEW_PROFILE = `${baseUrl}`;
export const DASHBOARD_ANALYTIC = `${baseUrl}auth/dashboard`;
export const EDIT_PROFILE = `${baseUrl}`;
export const PASSWORD_CHANGE = `${baseUrl}`;

// Aspiration 
// Aspiration Question
export const ASPIRATION_QUESTION_LIST = `${baseUrl}questions/list`;
export const ASPIRATION_QUESTION_CREATE = `${baseUrl}questions/create`;
export const ASPIRATION_QUESTION_UPDATE = `${baseUrl}questions/update`;
export const ASPIRATION_QUESTION_VIEW = `${baseUrl}questions/view`;
export const ASPIRATION_QUESTION_SORT = `${baseUrl}questions/sort`;
export const ASPIRATION_QUESTION_DELETE = `${baseUrl}questions/delete`;

// Aspiration Text
export const ASPIRATION_TEXT_LIST = `${baseUrl}questions`;
export const ASPIRATION_TEXT_CREATE = `${baseUrl}questions/text/create`;
export const ASPIRATION_TEXT_UPDATE = `${baseUrl}questions/text/update`;
export const ASPIRATION_TEXT_VIEW = `${baseUrl}questions/text/view`;
export const ASPIRATION_TEXT_DELETE = `${baseUrl}questions/text/delete`;

// schor horizontal
export const SCHOR_HORIZONTAL_LIST = `${baseUrl}questions/horizontal/list`;
export const SCHOR_HORIZONTAL_CREATE = `${baseUrl}questions/horizontal/create`;
export const SCHOR_HORIZONTAL_UPDATE = `${baseUrl}questions/horizontal/update`;
export const SCHOR_HORIZONTAL_VIEW = `${baseUrl}questions/horizontal/view`;
export const SCHOR_HORIZONTAL_SORT = `${baseUrl}questions/horizontal/sort`;
export const SCHOR_HORIZONTAL_DELETE = `${baseUrl}questions/horizontal/delete`;

// schor horizontal Text
export const SCHOR_HORIZONTAL_TEXT_LIST = `${baseUrl}questions/horizontal`;
export const SCHOR_HORIZONTAL_TEXT_CREATE = `${baseUrl}questions/horizontal/text/create`;
export const SCHOR_HORIZONTAL_TEXT_UPDATE = `${baseUrl}questions/horizontal/text/update`;
export const SCHOR_HORIZONTAL_TEXT_VIEW = `${baseUrl}questions/horizontal/text/view`;
export const SCHOR_HORIZONTAL_TEXT_DELETE = `${baseUrl}questions/horizontal/text/delete`;

// schor vertical
export const SCHOR_VERTICAL_LIST = `${baseUrl}questions/vertical/list`;
export const SCHOR_VERTICAL_CREATE = `${baseUrl}questions/vertical/create`;
export const SCHOR_VERTICAL_UPDATE = `${baseUrl}questions/vertical/update`;
export const SCHOR_VERTICAL_VIEW = `${baseUrl}questions/vertical/view`;
export const SCHOR_VERTICAL_SORT = `${baseUrl}questions/vertical/sort`;
export const SCHOR_VERTICAL_DELETE = `${baseUrl}questions/vertical/delete`;

// schor vertical Text
export const SCHOR_VERTICAL_TEXT_LIST = `${baseUrl}questions/vertical`;
export const SCHOR_VERTICAL_TEXT_CREATE = `${baseUrl}questions/vertical/text/create`;
export const SCHOR_VERTICAL_TEXT_UPDATE = `${baseUrl}questions/vertical/text/update`;
export const SCHOR_VERTICAL_TEXT_VIEW = `${baseUrl}questions/vertical/text/view`;
export const SCHOR_VERTICAL_TEXT_DELETE = `${baseUrl}questions/vertical/text/delete`;


// Questionnaire Question
export const QUESTIONNAIRE_LIST = `${baseUrl}questionnaire/list`;
export const QUESTIONNAIRE_CREATE = `${baseUrl}questionnaire/create`;
export const QUESTIONNAIRE_UPDATE = `${baseUrl}questionnaire/update`;
export const QUESTIONNAIRE_VIEW = `${baseUrl}questionnaire/view`;
export const QUESTIONNAIRE_SORT = `${baseUrl}questionnaire/sort`;
export const QUESTIONNAIRE_DELETE = `${baseUrl}questionnaire/delete`;
export const QUESTIONNAIRE_QUESTIONS_SORT = `${baseUrl}questionnaire`;

// Email
export const SEND_BATCH_MAIL = `${baseUrl}batch/email`;
export const BATCH_MAIL_LIST = `${baseUrl}batch/emails`;

// Norms
export const GENERATE_GLOBAL_NORMS = `${baseUrl}batch/global-norms`;
export const GLOBAL_NORMS_LIST = `${baseUrl}batch/global-norms`;
export const GROUP_NORMS_CREATE = `${baseUrl}batch/group-norms`;
export const GROUP_NORMS_LIST = `${baseUrl}batch/group-norms`;
export const GROUP_NORMS_LIST_DETAILS = `${baseUrl}batch/group-norms`;


// Questionnaire Text
export const QUESTIONNAIRE_TEXT_LIST = `${baseUrl}questionnaire`;
export const QUESTIONNAIRE_TEXT_CREATE = `${baseUrl}questionnaire/question/create`;
export const QUESTIONNAIRE_TEXT_UPDATE = `${baseUrl}questionnaire/question/update`;
export const QUESTIONNAIRE_TEXT_VIEW = `${baseUrl}questionnaire/question/view`;
export const QUESTIONNAIRE_TEXT_DELETE = `${baseUrl}questionnaire/question/delete`;

//Participants Invites
export const PARTICIPANTS_INVITES_LIST = `${baseUrl}invitation/participants/list`;
export const PARTICIPANTS_INVITES_CREATE = `${baseUrl}invitation/participants/create`;
export const PARTICIPANTS_INVITES_UPDATE = `${baseUrl}invitation/participants/update`;
export const PARTICIPANTS_INVITES_VIEW = `${baseUrl}invitation/participants/view`;
export const PARTICIPANTS_INVITES_SORT = `${baseUrl}invitation/participants/sort`;
export const PARTICIPANTS_INVITES_DELETE = `${baseUrl}invitation/participants/delete`;

//Participants Invites Text
export const PARTICIPANTS_INVITES_TEXT_LIST = `${baseUrl}invitation/participants`;
export const PARTICIPANTS_INVITES_TEXT_CREATE = `${baseUrl}invitation/participants/text/create`;
export const PARTICIPANTS_INVITES_TEXT_UPDATE = `${baseUrl}invitation/participants/text/update`;
export const PARTICIPANTS_INVITES_TEXT_VIEW = `${baseUrl}invitation/participants/text/view`;
export const PARTICIPANTS_INVITES_TEXT_DELETE = `${baseUrl}invitation/participants/text/delete`;


//Raters Invites
export const RATERS_INVITES_LIST = `${baseUrl}invitation/raters/list`;
export const RATERS_INVITES_CREATE = `${baseUrl}invitation/raters/create`;
export const RATERS_INVITES_UPDATE = `${baseUrl}invitation/raters/update`;
export const RATERS_INVITES_VIEW = `${baseUrl}invitation/raters/view`;
export const RATERS_INVITES_SORT = `${baseUrl}invitation/raters/sort`;
export const RATERS_INVITES_DELETE = `${baseUrl}invitation/raters/delete`;

//Raters Invites Text
export const RATERS_INVITES_TEXT_LIST = `${baseUrl}invitation/raters`;
export const RATERS_INVITES_TEXT_CREATE = `${baseUrl}invitation/raters/text/create`;
export const RATERS_INVITES_TEXT_UPDATE = `${baseUrl}invitation/raters/text/update`;
export const RATERS_INVITES_TEXT_VIEW = `${baseUrl}invitation/raters/text/view`;
export const RATERS_INVITES_TEXT_DELETE = `${baseUrl}invitation/raters/text/delete`;

//Participants Reminders
export const PARTICIPANTS_REMINDERS_LIST = `${baseUrl}invitation/reminders/list`;
export const PARTICIPANTS_REMINDERS_CREATE = `${baseUrl}invitation/reminders/create`;
export const PARTICIPANTS_REMINDERS_UPDATE = `${baseUrl}invitation/reminders/update`;
export const PARTICIPANTS_REMINDERS_VIEW = `${baseUrl}invitation/reminders/view`;
export const PARTICIPANTS_REMINDERS_SORT = `${baseUrl}invitation/reminders/sort`;
export const PARTICIPANTS_REMINDERS_DELETE = `${baseUrl}invitation/reminders/delete`;

// Reminders Text
export const PARTICIPANTS_REMINDERS_TEXT_LIST = `${baseUrl}invitation/reminders`;
export const PARTICIPANTS_REMINDERS_TEXT_CREATE = `${baseUrl}invitation/reminders/text/create`;
export const PARTICIPANTS_REMINDERS_TEXT_UPDATE = `${baseUrl}invitation/reminders/text/update`;
export const PARTICIPANTS_REMINDERS_TEXT_VIEW = `${baseUrl}invitation/reminders/text/view`;
export const PARTICIPANTS_REMINDERS_TEXT_DELETE = `${baseUrl}invitation/reminders/text/delete`;

// Batch
export const BATCH_LIST = `${baseUrl}batch/list`;
export const BATCH_TRACK_LIST = `${baseUrl}batch/track`;
export const BATCH_CREATE = `${baseUrl}batch/create`;
export const BATCH_UPDATE = `${baseUrl}batch/update`;
export const BATCH_VIEW = `${baseUrl}batch/view`;
export const BATCH_SORT = `${baseUrl}batch/sort`;
export const BATCH_DELETE = `${baseUrl}batch/delete`;

export const BATCH_GROUP_REPORT = `${baseUrl}batch/group-report`;
export const SCORE_BATCH = `${baseUrl}batch/score-batch`;
export const PARTICIPANT_SCORE_PDF = `${baseUrl}batch/participant/schor-pdf`;

// Participants
export const PARTICIPANTS_LIST = `${baseUrl}batch`;
export const PARTICIPANTS_TRACK_LIST = `${baseUrl}batch`;
export const PARTICIPANTS_CREATE = `${baseUrl}batch`;
export const PARTICIPANTS_UPDATE = `${baseUrl}batch`;
export const PARTICIPANTS_VIEW = `${baseUrl}batch`;
export const PARTICIPANTS_DELETE = `${baseUrl}batch`;
export const SEND_INVITATION_MAIL = `${baseUrl}batch/participant/send-mail`;
export const UPLOAD_CSV_PARTICIPANT = `${baseUrl}batch`;
export const PEERS_MERGE = `${baseUrl}batch/participant/peers-merge`;


// Configurations
// Language
export const LANGUAGE_LIST = `${baseUrl}config/language/list`;
export const LANGUAGE_CREATE = `${baseUrl}config/language/create`;
export const LANGUAGE_UPDATE = `${baseUrl}config/language/update`;
export const LANGUAGE_VIEW = `${baseUrl}config/language/view`;
export const LANGUAGE_SORT = `${baseUrl}config/language/sort`;
export const LANGUAGE_DELETE = `${baseUrl}config/language/delete`;

// ChartColor
export const CHARTCOLOR_LIST = `${baseUrl}config/color/list`;
export const CHARTCOLOR_UPDATE = `${baseUrl}config/color/update`;

//Survey Welcome
export const SURVEY_WELCOME_LIST = `${baseUrl}config/survey-text/start/list`;
export const SURVEY_WELCOME_CREATE = `${baseUrl}config/survey-text/start/create`;
export const SURVEY_WELCOME_UPDATE = `${baseUrl}config/survey-text/start/update`;
export const SURVEY_WELCOME_VIEW = `${baseUrl}config/survey-text/start/view`;
export const SURVEY_WELCOME_SORT = `${baseUrl}config/survey-text/start/sort`;
export const SURVEY_WELCOME_DELETE = `${baseUrl}config/survey-text/start/delete`;

//Survey Welcome
export const SURVEY_MIDDLE_LIST = `${baseUrl}config/survey-text/middle/list`;
export const SURVEY_MIDDLE_CREATE = `${baseUrl}config/survey-text/middle/create`;
export const SURVEY_MIDDLE_UPDATE = `${baseUrl}config/survey-text/middle/update`;
export const SURVEY_MIDDLE_VIEW = `${baseUrl}config/survey-text/middle/view`;
export const SURVEY_MIDDLE_SORT = `${baseUrl}config/survey-text/middle/sort`;
export const SURVEY_MIDDLE_DELETE = `${baseUrl}config/survey-text/middle/delete`;

//Survey Thank You
export const THANK_YOU_LIST = `${baseUrl}config/survey-text/last/list`;
export const THANK_YOU_CREATE = `${baseUrl}config/survey-text/last/create`;
export const THANK_YOU_UPDATE = `${baseUrl}config/survey-text/last/update`;
export const THANK_YOU_VIEW = `${baseUrl}config/survey-text/last/view`;
export const THANK_YOU_SORT = `${baseUrl}config/survey-text/last/sort`;
export const THANK_YOU_DELETE = `${baseUrl}config/survey-text/last/delete`;

// Raters Type
export const RATERS_TYPE_LIST = `${baseUrl}config/raters/list`;
export const RATERS_TYPE_CREATE = `${baseUrl}config/raters/create`;
export const RATERS_TYPE_UPDATE = `${baseUrl}config/raters/update`;
export const RATERS_TYPE_VIEW = `${baseUrl}config/raters/view`;
export const RATERS_TYPE_SORT = `${baseUrl}config/raters/sort`;
export const RATERS_TYPE_DELETE = `${baseUrl}config/raters/delete`;

// Raters Type Text
export const RATERS_TYPE_TEXT_LIST = `${baseUrl}config/raters`;
export const RATERS_TYPE_TEXT_CREATE = `${baseUrl}config/raters/text/create`;
export const RATERS_TYPE_TEXT_UPDATE = `${baseUrl}config/raters/text/update`;
export const RATERS_TYPE_TEXT_VIEW = `${baseUrl}config/raters/text/view`;
export const RATERS_TYPE_TEXT_DELETE = `${baseUrl}config/raters/text/delete`;

// Utiliy
export const LANGUAGE = `${baseUrl}utility/languages`;
export const QUESTION = `${baseUrl}utility/questions`;
export const QUESTIONNAIRE = `${baseUrl}utility/questionnaires`;
export const QUESTIONNAIRE_BATCH = `${baseUrl}utility/questionnaire/batch`;
export const RATERS_INVITATIONS = `${baseUrl}utility/raters/invitations`;
export const PARTICIPANTS_INVITATIONS = `${baseUrl}utility/participants/invitations`;
export const RATERS_REMINDERS = `${baseUrl}utility/raters/reminders`;
export const PARTICIPANTS_REMINDERS = `${baseUrl}utility/participants/reminders`;

// ********************************** => Participant Panel <= ***********************************
//LOGIN
export const POST_PARTICIPANT_LOGIN = `${baseUrl}survey`;
export const POST_PARTICIPANT_LOGOUT = `${baseUrl}survey`;

// Profile
export const VIEW_PARTICIPANT_PROFILE = `${baseUrl}survey`;
export const EDIT_PARTICIPANT_PROFILE = `${baseUrl}survey`;
export const PASSWORD_PARTICIPANT_CHANGE = `${baseUrl}survey`;

// raters invite
export const RATERS_INVITE_LIST = `${baseUrl}survey/participant/invite`;
export const SEND_MAIL = `${baseUrl}survey/participant/invite`
export const GET_TEMPLATE = `${baseUrl}survey/participant/invite/template`

// Survey
export const SURVEY_LIST = `${baseUrl}survey`;
export const SURVEY_EDIT = `${baseUrl}survey`;
export const GET_QUESTION = `${baseUrl}survey`;
export const MAIL_INVITE = `${baseUrl}survey/participant/invite`;
export const SAVE_QUESTION_ANSWER = `${baseUrl}survey`;


// Utiliy
export const HORIZONTAL_LIST = `${baseUrl}utility/horizontals`;
export const VERTICAL_LIST = `${baseUrl}utility/verticals`;

	// /api/v1/survey/participant/invite/template